import { useState } from "react"
import React from 'react'
import wave from "../resource/wave_final.png"
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from "axios"
import kgvHero from '../resource/kgvhero1.png';
import { Sparkles } from 'lucide-react';

export const ContactUs = () => {
  
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    address: "",
    query: ""
  })
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { firstName, lastName, email, phone, address, query } = formData

  // Handle input fields, when some value changes
  const handleOnChange = (e) => {
    setFormData((prevData) => ({
      ...prevData,
      [e.target.name]: e.target.value,
    }))
  }

  const handleOnSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      // Fixed: Changed endpoint from /register to /contact
      const response = await axios.post("https://auth.kgvl.co.in/contact", {
        name: firstName,
        lastname: lastName,
        email,
        phone,
        address,
        query,
      });
  
      // Fixed: Check for both 200 and 201 status codes, or use response.data.success
      if (response.status === 200 || response.status === 201 || response.data.success) {
        console.log(response.data);
        console.log("Query submitted successfully!");
        if (window.fbq) {
          window.fbq("track", "Contact", {
            content_category: "Query",
            content_name: query.substring(0, 50)
          });
        }
        
        // Show success toast
        toast.success('Query Raised successfully!', {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });

        // Reset form - Fixed: Removed password and confirmPassword fields
        setFormData({
          firstName: "",
          lastName: "",
          email: "",
          phone: "",
          address: "",
          query: ""
        });
      } else {
        console.error("Failed to submit query.");
        toast.error('Failed to submit query. Please try again.', {
          position: "bottom-right",
          autoClose: 3000,
        });
      }
    } catch (error) {
      console.error("Error submitting query:", error);
      
      // Show error toast with details
      const errorMessage = error.response?.data?.message || error.message || "An error occurred";
      toast.error(`Error: ${errorMessage}`, {
        position: "bottom-right",
        autoClose: 5000,
      });
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <div className="overflow-hidden relative">
      <img alt="background wave" src={wave} className="absolute -z-10" loading="lazy"/>
      <ToastContainer />

      <div className="flex-col items-center mx-auto w-11/12">
        <div className="text-center my-8 px-4">
          <h2 className="text-2xl font-bold text-green-600">Contact Us</h2>
          <p className="max-w-xl mx-auto mt-2 text-gray-700">
            We'd love to hear from you! Whether you have questions about our products, need assistance, or want to explore partnership opportunities, we're here to help.
            <br />
            <span className="flex items-center justify-center gap-2 mt-4 text-green-700 font-semibold italic text-sm">
               <Sparkles className="w-4 h-4 text-green-500" />
               Queries prioritized via AI-Driven Intelligence
            </span>
          </p>
        </div>

        <div className="bg-white rounded-lg shadow-2xl p-6 my-12 max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 items-center border border-green-100">
          <style>{`
            @keyframes shimmerSweep {
              0% { transform: translateX(-100%); }
              50% { transform: translateX(100%); }
              100% { transform: translateX(100%); }
            }
            .shimmer-sweep {
              animation: shimmerSweep 3s infinite linear;
            }
          `}</style>
          {/* Contact Form */}
          <div className="relative">
             {/* Premium AI Badge */}
             <div className="absolute -top-12 left-0 group transition-all duration-500 hover:scale-110 active:scale-95">
                <span className="relative overflow-hidden bg-black/90 backdrop-blur-xl px-4 py-2 rounded-full shadow-[0_0_20px_rgba(34,197,94,0.4)] flex items-center gap-2 border border-green-500/50">
                  <span className="absolute inset-0 w-1/2 h-full bg-gradient-to-r from-transparent via-white/20 to-transparent -rotate-45 shimmer-sweep"></span>
                  <Sparkles className="w-3 h-3 text-green-400 animate-pulse" />
                  <span className="text-white text-[10px] font-black tracking-widest uppercase">
                    AI-POWERED <span className="text-transparent bg-clip-text bg-gradient-to-r from-green-400 to-emerald-400">SUPPORT</span>
                  </span>
                </span>
             </div>
             <form onSubmit={handleOnSubmit} className="space-y-6 mt-4">
            {/* Name Fields */}
            <div className="flex flex-col sm:flex-row gap-4">
              <div className="flex-1">
                <label className="block mb-1 text-sm font-semibold text-gray-700">
                  First Name <sup className="text-red-500">*</sup>
                </label>
                <div className="flex items-center bg-white p-2 rounded-md border border-green-500">
                  <input
                    required
                    type="text"
                    name="firstName"
                    value={firstName}
                    onChange={handleOnChange}
                    placeholder="Enter first name"
                    className="w-full outline-none"
                    disabled={isSubmitting}
                  />
                </div>
              </div>

              <div className="flex-1">
                <label className="block mb-1 text-sm font-semibold text-gray-700">
                  Last Name <sup className="text-red-500">*</sup>
                </label>
                <div className="flex items-center bg-white p-2 rounded-md border border-green-500">
                  <input
                    required
                    type="text"
                    name="lastName"
                    value={lastName}
                    onChange={handleOnChange}
                    placeholder="Enter last name"
                    className="w-full outline-none"
                    disabled={isSubmitting}
                  />
                </div>
              </div>
            </div>

            {/* Phone Field */}
            <div>
              <label className="block mb-1 text-sm font-semibold text-gray-700">
                Phone Number <sup className="text-red-500">*</sup>
              </label>
              <div className="flex items-center bg-white p-2 rounded-md border border-green-500">
                <input
                  required
                  type="text"
                  name="phone"
                  value={phone}
                  onChange={handleOnChange}
                  placeholder="Enter 10-digit phone number"
                  className="w-full outline-none"
                  disabled={isSubmitting}
                />
              </div>
            </div>

            {/* Email Field */}
            <div>
              <label className="block mb-1 text-sm font-semibold text-gray-700">
                Email Address <sup className="text-red-500">*</sup>
              </label>
              <div className="flex items-center bg-white p-2 rounded-md border border-green-500">
                <input
                  required
                  type="email"
                  name="email"
                  value={email}
                  onChange={handleOnChange}
                  placeholder="Enter email address"
                  className="w-full outline-none"
                  disabled={isSubmitting}
                />
              </div>
            </div>

            {/* Address Field */}
            <div>
              <label className="block mb-1 text-sm font-semibold text-gray-700">
                Address <sup className="text-red-500">*</sup>
              </label>
              <div className="flex items-center bg-white p-2 rounded-md border border-green-500">
                <input
                  required
                  type="text"
                  name="address"
                  value={address}
                  onChange={handleOnChange}
                  placeholder="Enter address"
                  className="w-full outline-none"
                  disabled={isSubmitting}
                />
              </div>
            </div>

            {/* Query Field */}
            <div>
              <label className="block mb-1 text-sm font-semibold text-gray-700">
                Query <sup className="text-red-500">*</sup>
              </label>
              <textarea
                required
                name="query"
                value={query}
                onChange={handleOnChange}
                placeholder="Enter query"
                className="w-full border rounded-md px-3 py-2 resize-none h-28 outline-none border-green-500"
                disabled={isSubmitting}
              />
            </div>

            {/* Submit Button */}
            <div className="flex justify-center">
              <button
                type="submit"
                disabled={isSubmitting}
                className="bg-[#57E226] hover:bg-green-600 text-white font-semibold px-6 py-3 rounded-md transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {isSubmitting ? 'Submitting...' : 'Raise A Query'}
              </button>
            </div>
          </form>
        </div>

          {/* Image */}
          <div className="flex justify-center items-center">
            <img src={kgvHero} alt="KGV Hero" className="w-full h-auto max-h-[500px] object-contain rounded-full" />
          </div>
        </div>
      </div>
    </div>
  )
}


// import { useState } from "react"
// import React from 'react'
// import wave from "../resource/wave_final.png"
// import { BusinessBook } from "../components/BusinessBook"
// import { ContactCompany } from "../components/ContactCompany"
// import { MdEmail } from "react-icons/md";
// import { FaLocationDot } from "react-icons/fa6";
// import { FaUser } from "react-icons/fa";
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import axios from "axios"

//  export const ContactUs=()=> {
  
//   // student or instructor

//   const [formData, setFormData] = useState({
//     firstName: "",
//     lastName: "",
//     email: "",
//     address: "",
//     query:""
//   })



//   const { firstName, lastName, email, address, query } = formData

//   // Handle input fields, when some value changes
//   const handleOnChange = (e) => {
//     setFormData((prevData) => ({
//       ...prevData,
//       [e.target.name]: e.target.value,
//     }))
//   }

//   // Handle Form Submission
//   const handleOnSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       const response = await axios.post("https://kgvbsckend-9-7-24.onrender.com/register", {
//         name: firstName,
//         lastname: lastName,
//         email,
//         address,
//         query,
//       });
  
//       if (response.status === 200) {
//         console.log(response);
//         console.log("Query submitted successfully!");
//         tostershow();
//       } else {
//         console.error("Failed to submit query.");
//       }
//     } catch (error) {
//       console.error("Error submitting query:", error);
//     }
  
    
//     // Reset
//     setFormData({
//       firstName: "",
//       lastName: "",
//       email: "",
//       password: "",
//       confirmPassword: "",
//       address: "",
//     query:""
//     })

//   }
//   const tostershow = () => {
//     // Show toast message
//     toast.success('Query Raised successfully!', {
//       position: "bottom-right",
//       autoClose: 3000, // 3 seconds
//       hideProgressBar: false,
//       closeOnClick: true,
//       pauseOnHover: true,
//       draggable: true,
//       progress: undefined,
//     });

//     // Navigate to dashboard after a delay (adjust as needed)
//   }

//   return (
//     <div className=" overflow-hidden relative  ">
//          <img alt="aaa" src={wave} className="absolute -z-10 " loading="lazy"/>

//     <div className="flex-col  items-center  mx-auto w-11/12">
    
//     <div class="flex  items-center justify-center py-10 rounded-lg bg-black bg-opacity-10    font-inter w-full   mx-auto mt-14 px-10 ">
//          {/* Form */}
//          <form
//             onSubmit={handleOnSubmit}
//             className="flex flex-col h-full  gap-y-4 font-inter"
//           >
//             <div className="  sm:flex  justify-center gap-9    ">
//               <div className="flex flex-col">
//                 <div className="flex min-[320px]:flex-col sm:flex-row gap-x-4">
//                   <label className="mb-[1rem]">
//                     <p className="mb-1 text-[0.875rem] font-semibold leading-[1.375rem] black">
//                       First Name <sup className="text-pink-200">*</sup>
//                     </p>
//                     <div className="bg-white p-2 flex flex-row items-center mr-2  rounded-md">
//                     <FaUser className="text-black mr-2" />
//                     <input
//                       required
//                       type="text"
//                       name="firstName"
//                       value={firstName}
//                       onChange={handleOnChange}
//                       placeholder="Enter first name"
//                       style={{
//                         boxShadow:
//                           "inset 0px -1px 0px rgba(255, 255, 255, 0.18)",
//                       }}
//                       className="w-full rounded-[0.5rem]   p-1 outline-none "
//                     />
//                     </div>
//                   </label>
//                   <label>
//                     <p className="mb-1 font-semibold text-[0.875rem] leading-[1.375rem] text-richblack-5">
//                       Last Name <sup className="text-pink-200">*</sup>
//                     </p>
//                     <div className="bg-white p-2 flex flex-row items-center mr-2  rounded-md">
//                     <FaUser className="text-black mr-2" />
//                     <input
//                       required
//                       type="text"
//                       name="lastName"
//                       value={lastName}
//                       onChange={handleOnChange}
//                       placeholder="Enter last name"
//                       style={{
//                         boxShadow:
//                           "inset 0px -1px 0px rgba(255, 255, 255, 0.18)",
//                       }}
//                       className="w-full rounded-[0.5rem]  p-1 outline-none "
//                     />
//                     </div>
//                   </label>
                  
//                 </div>
//                 <label className="w-full mb-[1rem]">
//                   <p className="mb-1 text-[0.875rem] font-semibold leading-[1.375rem] text-richblack-5">
//                     Email Address <sup className="text-pink-200">*</sup>
//                   </p>
//                   <div className="bg-white p-2 flex flex-row items-center mr-4  rounded-md">
//                   <MdEmail className="text-black mr-2" />
//                   <input
//                     required
//                     type="text"
//                     name="email"
//                     value={email}
//                     onChange={handleOnChange}
//                     placeholder="Enter email address"
//                     style={{
//                       boxShadow: "inset 0px -1px 0px rgba(255, 255, 255, 0.18)",
//                     }}
//                     className="w-full rounded-[0.5rem]  p-1 outline-none"
//                   />
//                   </div>
//                 </label>

//                 <label className="relative mb-2">
//                   <p className="mb-1 text-[0.875rem] font-semibold leading-[1.375rem] text-richblack-5">
//                     Address<sup className="text-pink-200">*</sup>
//                   </p>
//                   <div className="bg-white p-2 flex flex-row items-center mr-4  rounded-md">
//                     <FaLocationDot className="text-black mr-2" />
//                     <input
//                       required
//                       type="text"
//                       name="address"
//                       value={address}
//                       onChange={handleOnChange}
//                       placeholder="Enter address"
//                       style={{
//                         boxShadow:
//                           "inset 0px -1px 0px rgba(255, 255, 255, 0.18)",
//                       }}
//                       className="w-full rounded-[0.5rem]   p-1 pr-10 outline-none"
//                     />
//                   </div>
//                 </label>
//               </div>

//               <div className=" h-full ">
//                 <label className=" h-full">
//                   <p className="mb-1 text-[0.875rem] font-semibold leading-[1.375rem] text-richblack-5">
//                     Query <sup className="text-pink-200">*</sup>
//                   </p>
//                   <textarea
//                     required
//                     type="text"
//                     name="query"
//                     value={query}
//                     onChange={handleOnChange}
//                     placeholder="Enter query"
//                     style={{
//                       boxShadow: "inset 0px -1px 0px rgba(255, 255, 255, 0.18)",
//                     }}
//                     className="w-[95%] sm:h-[33vh]   rounded-[0.5rem]  p-[12px]  text-black outline-none"
//                   />
//                 </label>
//               </div>
//             </div>
//             <div className="flex items-center justify-center ">
//               {" "}
//               <button
//                 type="submit"
//                 className=" md:text-[60%] sm:text-[60%] py-3 px-5 rounded-md bg-[#57E226] font-inter font-semibold  min-[320px]:text-[70%]  sm:py-3 sm:px-5"
//                 onClick={handleOnSubmit} 
//               >
//                 Raise A Query
//               </button>
//             </div>
//           </form>
        
//     </div>
//     <ToastContainer />
//    </div>
// <div className="mt-14 " > 

// <BusinessBook/>
// </div>

//   <ContactCompany/>
   

//     </div>
      
    
//   )
// }